<template>
  <div class="media-tab-main scrollbar" v-loader.opacity.tab="loading">
    <div v-if="examImages.length > 0">
      <lightgallery-vue class="image-info-box grid-wrap-between ease-all" ref="lGallery" id="lightgallery"
        :settings="lightGallerySettings" :onBeforeSlide="removeDownloadButton" :onAfterOpen="extraCustomization">
        <template v-for="(item, index) in examImages" :key="index">

          <a v-if="item.type.endsWith('VIDEO')" onclick="return false" class="thumbnail-box loading-eye"
            :class="item.type" :key="`video_${index}`" data-lg-size="1280-720" :data-test="`anchorVideo_${index}`"
            :data-video="getVideoSource(item)" data-download-url="" data-sub-html="<h4></h4><p></p>">
            <img class="lg-selector ease-all" src="@/assets/images/default-video2.png" alt=""
              @load="removeLoading($event)" />
            <div class="thumb-actions">
              <!-- <div class="btn-group btn-group-sm" role="group" aria-label="Thumb actions">
                <button class="btn btn-outline-secondary group" type="button" name="button"
                  :data-test="`btnDownloadImage_${index}`" @click.stop.prevent="doDownload(item)">
                  <i class="fa fa-download"></i>
                </button>
              </div> -->
            </div>
          </a>

          <a v-else class="thumbnail-box loading-eye" onclick="return false" :class="item.type"
            :href="dataPath + '/' + item.name" :data-test="`anchorImage_${index}`">
            <img class="lg-selector ease-all" :src="thumbDataPath + '/' + item.name" alt="" @load="removeLoading($event)" />
            <div class="thumb-actions">
              <div class="btn-group btn-group-sm" role="group" aria-label="Thumb actions">
                <button class="btn btn-outline-secondary group" type="button" name="button"
                  :data-test="`btnDownloadImage_${index}`" @click.stop.prevent="doDownload(item)">
                  <i class="fa fa-download"></i>
                </button>
              </div>
            </div>
          </a>
        </template>
      </lightgallery-vue>
    </div>

    <div class="no-results-box" v-else-if="!loading && !examImages.length">
      <BaseNoResults :title="$t('externalPatient.emptyMediaTitle')" :text="$t('externalPatient.emptyMediaText')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.media-tab-main {
  width:                          100%;
  min-height:                     440px;
  max-height:                     440px;
  overflow-y:                     auto;
  overflow-x:                     hidden;
  margin-bottom:                  26px;
}

:deep(.loading-overlay) {
  min-height:                     auto !important;
}

.image-info-box {
  width:                          100%;
  &.grid-wrap-between {
    grid-template-columns:        repeat(auto-fill, 32%) !important;
  }
  .thumbnail-box {
    img {
      aspect-ratio:               87 / 74;
    }
  }
  .thumb-actions {
    .btn-group .btn:last-child {
      @include                    border_radius(99px);
      padding:                    6.244px 12.489px;
    }
  }
}

.no-results-box {
  width:                          100%;
  display:                        flex;
  flex-direction:                 column;
  align-items:                    center;
  text-align:                     center;
}

@media (min-width: 768px) {
  .media-tab-main {
    min-height:                   370px;
    max-height:                   370px;
  }
}

@media (max-width: 991px) {
  .media-tab-main {
    max-height:                   unset !important;
    height:                       auto !important;
    overflow-y:                   visible !important;
    padding-right:                0;
  }

  .image-info-box.grid-wrap-between {
    grid-template-columns:        repeat(auto-fill, 48%) !important;
  }
}
</style>

<script>
import lgAutoplay from 'lightgallery/plugins/autoplay';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from '@/assets/dependencies/lightGallery/plugins/zoom';

const IS_PRODUCTION = process.env.NODE_ENV == 'production'

export default {
  name: 'ExternalExamMediaTab',
  data: () => ({
    loading: false,
    examImages: [],
    dataPath: '',
    thumbDataPath: '',
    lightGallerySettings: {
      showZoomInOutIcons: true,
      actualSize: false,
      autoplayVideoOnSlide: true,
      speed: 300,
      controls: true,
      licenseKey: 'CE440F6C-34CE4C2A-86065648-48895C83',
      plugins: [lgAutoplay, lgFullscreen, lgThumbnail, lgVideo, lgZoom],
    },
    examID: null,
  }),
  created() {
    this.examID = this.$route.params.examID
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      NProgress.start();
      try {
        let response = await this.$externalService.getExam({id: this.examID});
        let examDataList = response.examDataList || [];
        this.examImages = examDataList.filter(file => !file.type.startsWith('OTHER_') && file.type !== 'RNFL_RAW');
        
        this.thumbDataPath = `${response.thumbDataPath}`;
        this.dataPath = `${response.dataPath}`;

        // TODO move to service
        if (!IS_PRODUCTION) {
          this.thumbDataPath = `http://localhost:1337${response.thumbDataPath}`;
          this.dataPath = `http://localhost:1337${response.dataPath}`;
        }
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    async doDownload(item) {
      this.loading = true;
      NProgress.start();
      try {
        let params = {};
        if (item.id) 
          params['id'] = item.id;

        if (item.uuid) 
          params['uuid'] = item.uuid;

        const url = this.$externalService.getDownloadFileUrl(params);
        this.$utils.triggerFileDownload(url);
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error');
      } finally {
        NProgress.done(true);
        this.loading = false;
      }
    },
    getVideoSource(item) {
      let result = {
        "source": [{ "src": `${this.dataPath}/${item.name}?autoplay=1`, "type": "video/mp4" }],
        "attributes": { "preload": false, "playsinline": false, "controls": true, "loop": true }
      }
      return JSON.stringify(result)
    },
    removeLoading(event) {
      let parentNode = event.target.parentElement.classList;
      let currentlyNode = event.target.classList;
      this.$nextTick(() => {
        currentlyNode.add('loaded')
        parentNode.remove('loading-eye')
      });
    },
    removeDownloadButton(value) {
      let item = this.examImages[value.index]
      if (item && item.type.endsWith('VIDEO'))
        document.querySelector('.lg-download').style.display = 'none'
      else
        document.querySelector('.lg-download').style.display = ''
    },
    extraCustomization() {
      let self = this
      $(".lg-download").off("click").on("click", function (event) {
        event.preventDefault();
        let examDataUUID = this.href.split('/').pop()
        let item = { uuid: examDataUUID }
        self.doDownload(item)
      })
    },
  }
}
</script>